import { Component, EventEmitter, Input, Output } from '@angular/core';
import {LanguageUtils} from '../../shared/utils/src/language.utils';

@Component({
    selector: 'bsp-tab',
    templateUrl: './tab.component.html',
    styleUrls: [ './tab.component.scss']
})

export class TabComponent {
    @Input() public selectedTab: String;
    @Input() public tabConfig: Array<any> = [];
    @Input() public tabStyleClassName: String;
    @Output() public tabClicked: EventEmitter<any> = new EventEmitter();

    public tabClick(id: any) {
        LanguageUtils.setLanguage();

        this.tabClicked.emit(id);
        this.selectedTab = id;
        return false;
    }

}




// WEBPACK FOOTER //
// ./src/app/components/tab/tab.component.ts